import {
  AccountId,
  ApiResponse,
  OfferingId,
  OfferingTransaction,
  OfferingTransactionDocument,
  OfferingTransactionId,
  SignDocumentRequest,
  UserId,
} from '@arrived/models';

import { api } from './api';
import { getBlob, unwrapApiResponse } from './utils';

export const getOfferingTransactionDocumentsPreviewAsPdf = async (offeringTransactionId: OfferingTransactionId) => {
  return await getBlob(`/trades/${offeringTransactionId}/documents/pdf/preview`);
};

export const postSignOfferingTransactionDocuments = async (request: SignDocumentRequest) => {
  const response = await api.post<ApiResponse<OfferingTransaction>>(
    `/trades/${request.offeringTransactionId}/documents/sign`,
    request
  );

  return unwrapApiResponse(response.data);
};

export const getOfferingTransactionDocuments = async (offeringTransactionId: OfferingTransactionId) => {
  const response = await api.get<ApiResponse<OfferingTransactionDocument>>(
    `/trades/${offeringTransactionId}/documents`
  );

  return unwrapApiResponse(response.data);
};

export const deleteOfferingTransactionDocuments = async (offeringTransactionId: OfferingTransactionId) => {
  const response = await api.delete<ApiResponse<OfferingTransactionDocument>>(
    `/trades/${offeringTransactionId}/documents`
  );

  return unwrapApiResponse(response.data);
};

export const getOfferingTransactionDocumentsAsPdf = async (offeringTransactionId: OfferingTransactionId) => {
  return await getBlob(`/trades/${offeringTransactionId}/documents/pdf`);
};

export const getOfferingTransactionDocumentsForOffering = async (offeringId: OfferingId) => {
  const response = await api.get<ApiResponse<OfferingTransactionDocument[]>>(
    `/trades/documents/offerings/${offeringId}`
  );

  return unwrapApiResponse(response.data);
};

export const getOfferingTransactionDocumentsForUser = async (userId: UserId) => {
  const response = await api.get<ApiResponse<OfferingTransactionDocument[]>>(`/trades/documents/users/${userId}`);

  return unwrapApiResponse(response.data);
};

export const getOfferingTransactionDocumentsForAccount = async (accountId: AccountId) => {
  const response = await api.get<ApiResponse<OfferingTransactionDocument[]>>(`/trades/documents/accounts/${accountId}`);

  return unwrapApiResponse(response.data);
};
